var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.52 6.94675L22.3999 10.7067C22.6533 11.2267 23.3333 11.7201 23.9066 11.8267L27.3066 12.3867C29.4799 12.7467 29.9866 14.3201 28.4266 15.8934L25.7733 18.5467C25.3333 18.9867 25.08 19.8534 25.2266 20.4801L25.9866 23.7601C26.5866 26.3468 25.1999 27.3601 22.9199 26.0001L19.7333 24.1067C19.1599 23.7601 18.1999 23.7601 17.6266 24.1067L14.4399 26.0001C12.1599 27.3467 10.7733 26.3468 11.3733 23.7601L12.1333 20.4801C12.2799 19.8667 12.0266 19.0001 11.5866 18.5467L8.93328 15.8934C7.37328 14.3334 7.87995 12.7601 10.0533 12.3867L13.4533 11.8267C14.0266 11.7334 14.7066 11.2267 14.9599 10.7067L16.8399 6.94675C17.8399 4.90675 19.4933 4.90675 20.52 6.94675Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6665 6.66675H2.6665",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 25.3334H2.6665",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.99984 16H2.6665",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.1ebbad03d8e01a6392136af0af2c5692.svg";
export { ForwardRef as ReactComponent };